import { useGet } from './useApi';
import { Student } from '../models/student.model';
import { normalizeAppPinsFromStudents } from '../utils/appPin';

export type OrganizationAccountLink = {
  id: number;
  userId: number;
  accountName: string;
};

export type StudentWithProps = Student & {
  additionalGuardians: any[];
  emergencyContacts: any[];
  medicalInfo: any;
  sharingInfo: any;
  enrollmentBlocked: any;
  studentsSubsidyEligible: any | null;
  /** Registration windows this student has already paid the fee for. */
  paidRegistrationWindowIds?: number[];
  /** Organizations linked to this student's family (per family, not per student). */
  organizationAccounts?: OrganizationAccountLink[];
};

export const useGetStudents = () => {
  return useGet<StudentWithProps[]>('/v1/auth/reg/students', {
    refetchOnMount: false,
    refetchInterval: false,
    refetchOnReconnect: false,
    select: (students) => {
      if (!students || !students.length) {
        return [] as StudentWithProps[];
      }

      return normalizeAppPinsFromStudents(students) as StudentWithProps[];
    },
  });
};
